enum PinLegendClassificationType {
  NATURAL_BREAKS = "Natural",
  QUANTILE = "Quantile",
  EQUAL_INTERVAL = "EqualInterval",
  MANUAL = "Manual",
  SIMPLE = "Simple",
}

export default PinLegendClassificationType;
